import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
const decodeHtmlEntities = str => {
  if (!str) return '';
  const txt = document.createElement('textarea');
  txt.innerHTML = str;
  return txt.value;
};
const normalize = str => {
  return (str || '').trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

// Singleton Loader for Players Dictionary
const loadNagusiPlayersDictionary = () => {
  if (app.nagusiPlayersPromise) {
    return app.nagusiPlayersPromise;
  }
  if (app.nagusiPlayersDictionary) {
    return Promise.resolve(app.nagusiPlayersDictionary);
  }
  app.nagusiPlayersPromise = app.request({
    method: 'GET',
    url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/players-dictionary'
  }).then(response => {
    var _response$data;
    app.nagusiPlayersDictionary = ((_response$data = response.data) == null ? void 0 : _response$data.attributes) || {
      photos: {},
      aliases: {}
    };
    return app.nagusiPlayersDictionary;
  }).catch(err => {
    console.error(err);
    return {
      photos: {},
      aliases: {}
    };
  });
  return app.nagusiPlayersPromise;
};
export default class Lineup extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "dictionary", {
      photos: {},
      aliases: {}
    });
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;
    loadNagusiPlayersDictionary().then(dict => {
      this.dictionary = dict;
      this.loading = false;
      m.redraw();
    });
  }
  view() {
    if (this.loading) {
      return m("div", {
        className: "Lineup-container Lineup--loading",
        style: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '200px'
        }
      }, m("i", {
        className: "fas fa-spinner fa-spin"
      }));
    }
    const formation = this.attrs.formation || '4-4-2';
    const isRealSociedad = app.forum.attribute('nagusiMatchRatingsClubSlug') === 'real-sociedad';
    const kit = this.attrs.kit || (isRealSociedad ? 'stripes-blue-white' : 'athletic');
    const playersRaw = decodeHtmlEntities(this.attrs.players || '');
    const playersData = playersRaw.split(',').filter(Boolean);
    const starters = playersData.slice(0, 11);
    const substitutes = playersData.slice(11);
    const isMini = this.attrs.mini;
    return m("div", {
      className: "Lineup-container ".concat(isMini ? 'Lineup--mini' : '')
    }, m("div", {
      className: "Lineup-field Lineup-formation-".concat(formation)
    }, m("div", {
      className: "Lineup-area Lineup-area--top"
    }), m("div", {
      className: "Lineup-goal-area Lineup-area--top"
    }), m("div", {
      className: "Lineup-area Lineup-area--bottom"
    }), m("div", {
      className: "Lineup-goal-area Lineup-area--bottom"
    }), m("div", {
      className: "Lineup-corner Lineup-corner--top-left"
    }), m("div", {
      className: "Lineup-corner Lineup-corner--top-right"
    }), m("div", {
      className: "Lineup-corner Lineup-corner--bottom-left"
    }), m("div", {
      className: "Lineup-corner Lineup-corner--bottom-right"
    }), starters.map((data, index) => {
      let name = '';
      let dorsal = '';
      let playerId = null;
      if (data.includes(':')) {
        const parts = data.split(':');
        if (parts.length >= 3 && !isNaN(Number(parts[1]))) {
          dorsal = parts[0] === '?' ? '' : parts[0];
          playerId = Number(parts[1]);
          name = parts.slice(2).join(':');
          if (name === '?') name = '';
        } else {
          dorsal = parts[0] === '?' ? '' : parts[0];
          name = parts.slice(1).join(':');
          if (name === '?') name = '';
        }
      } else {
        name = data === '?' ? '' : data;
      }

      // If name is missing but playerId exists, look up in dictionary or store
      if (!name && playerId) {
        if (this.dictionary.names_by_id && this.dictionary.names_by_id[playerId]) {
          name = this.dictionary.names_by_id[playerId];
        } else {
          const pById = app.store.getById('nagusi_players', String(playerId));
          if (pById) {
            name = pById.attribute('name');
            if (!dorsal && pById.number()) {
              dorsal = String(pById.number());
            }
          }
        }
      }
      const searchNameNorm = normalize(name);
      const isGK = index === 0;
      const kitClass = isGK ? 'Lineup-kit-gk' : "Lineup-kit-".concat(kit);
      const isActive = this.attrs.interactive && this.attrs.activePosition === index;
      const isInteractive = this.attrs.interactive;
      const displayName = name || (isInteractive && this.attrs.getPositionName ? this.attrs.getPositionName(index) : '');
      if (!searchNameNorm) {
        return m("div", {
          className: "Lineup-player Lineup-pos-".concat(index + 1, " ").concat(isActive ? 'Lineup-player--active' : '', " ").concat(isInteractive ? 'Lineup-player--interactive' : '', " ").concat(!name ? 'Lineup-player--empty' : ''),
          key: index,
          onclick: e => {
            if (isInteractive && this.attrs.onPlayerClick) {
              e.preventDefault();
              this.attrs.onPlayerClick(index);
            }
          }
        }, m("div", {
          className: "Lineup-player-dot ".concat(kitClass)
        }, dorsal ? m("span", {
          className: "Lineup-player-number"
        }, dorsal) : isInteractive ? m("span", {
          className: "Lineup-player-plus"
        }, "+") : null), m("div", {
          className: "Lineup-player-name"
        }, displayName));
      }
      let officialName = name;
      let aliasesStr = '';
      const lineupPlayer = app.store.all('nagusi_players').find(p => {
        const pNameNorm = normalize(p.attribute('name'));
        const pAliases = (p.attribute('aliases') || '').split(/[;,]/).map(s => normalize(s));
        return pNameNorm === searchNameNorm || pAliases.includes(searchNameNorm);
      });
      if (lineupPlayer) {
        officialName = lineupPlayer.attribute('name');
        aliasesStr = lineupPlayer.attribute('aliases') || '';
      } else {
        // FALLBACK: Use local dictionary aliases
        const localLineupPlayers = this.dictionary.aliases || {};
        const matchOfficial = Object.keys(localLineupPlayers).find(oname => {
          if (normalize(oname) === searchNameNorm) return true;
          const aliases = (localLineupPlayers[oname] || '').split(/[;,]/).map(s => normalize(s));
          return aliases.includes(searchNameNorm);
        });
        if (matchOfficial) {
          officialName = matchOfficial;
          aliasesStr = localLineupPlayers[matchOfficial] || '';
        }
      }
      const namesToTry = [name];
      if (officialName && !namesToTry.some(n => normalize(n) === normalize(officialName))) {
        namesToTry.push(officialName);
      }
      if (aliasesStr) {
        aliasesStr.split(/[;,]/).forEach(a => {
          const trimmedA = a.trim();
          if (trimmedA && !namesToTry.some(n => normalize(n) === normalize(trimmedA))) {
            namesToTry.push(trimmedA);
          }
        });
      }

      // Search in local dictionary photos or by ID directly
      const localPhotos = this.dictionary.photos || {};
      let photoUrl = null;
      if (playerId) {
        let idMatches = false;
        if (this.dictionary.names_by_id && this.dictionary.names_by_id[playerId]) {
          const idOfficialName = this.dictionary.names_by_id[playerId];
          const idAliasesStr = this.dictionary.aliases ? this.dictionary.aliases[idOfficialName] || '' : '';
          const validNamesForId = [idOfficialName, ...idAliasesStr.split(/[;,]/).map(s => s.trim())].filter(Boolean);
          if (namesToTry.some(nt => validNamesForId.some(vn => normalize(vn) === normalize(nt)))) {
            idMatches = true;
          }
        } else {
          const pById = app.store.getById('nagusi_players', String(playerId));
          if (pById) {
            const idOfficialName = pById.attribute('name');
            const idAliasesStr = pById.attribute('aliases') || '';
            const validNamesForId = [idOfficialName, ...idAliasesStr.split(/[;,]/).map(s => s.trim())].filter(Boolean);
            if (namesToTry.some(nt => validNamesForId.some(vn => normalize(vn) === normalize(nt)))) {
              idMatches = true;
            }
          }
        }
        if (idMatches) {
          if (this.dictionary.photos_by_id && this.dictionary.photos_by_id[playerId]) {
            photoUrl = this.dictionary.photos_by_id[playerId];
          }
          if (!photoUrl) {
            const pById = app.store.getById('nagusi_players', String(playerId));
            if (pById && pById.attribute('photoUrl')) {
              photoUrl = pById.attribute('photoUrl');
            }
          }
        }
      }
      if (!photoUrl) {
        for (const n of namesToTry) {
          const nNorm = normalize(n);
          const matchKey = Object.keys(localPhotos).find(kn => normalize(kn) === nNorm);
          if (matchKey) {
            photoUrl = localPhotos[matchKey];
            break;
          }
        }
      }

      // Fallback: Search in nagusi_players store directly
      if (!photoUrl) {
        const playerFromRatings = app.store.all('nagusi_players').find(p => {
          const pNameNorm = normalize(p.attribute('name'));
          return namesToTry.some(n => normalize(n) === pNameNorm);
        });
        photoUrl = playerFromRatings ? playerFromRatings.attribute('photoUrl') : null;
      }
      return m("div", {
        className: "Lineup-player Lineup-pos-".concat(index + 1, " ").concat(isActive ? 'Lineup-player--active' : '', " ").concat(isInteractive ? 'Lineup-player--interactive' : ''),
        key: index,
        onclick: e => {
          if (isInteractive && this.attrs.onPlayerClick) {
            e.preventDefault();
            this.attrs.onPlayerClick(index);
          }
        }
      }, m("div", {
        className: "Lineup-player-dot ".concat(photoUrl ? 'Lineup-player-with-photo' : kitClass)
      }, photoUrl ? m("img", {
        src: photoUrl,
        alt: name,
        className: "Lineup-player-img"
      }) : dorsal && m("span", {
        className: "Lineup-player-number"
      }, dorsal)), m("div", {
        className: "Lineup-player-name"
      }, displayName));
    })), substitutes.length > 0 && m("div", {
      className: "Lineup-bench"
    }, m("div", {
      className: "Lineup-bench-title"
    }, m("i", {
      className: "fas fa-couch"
    }), " Banquillo"), m("div", {
      className: "Lineup-bench-players"
    }, substitutes.map((data, index) => {
      let name = '';
      let dorsal = '';
      let playerId = null;
      if (data.includes(':')) {
        const parts = data.split(':');
        if (parts.length >= 3 && !isNaN(Number(parts[1]))) {
          dorsal = parts[0] === '?' ? '' : parts[0];
          playerId = Number(parts[1]);
          name = parts.slice(2).join(':');
          if (name === '?') name = '';
        } else {
          dorsal = parts[0] === '?' ? '' : parts[0];
          name = parts.slice(1).join(':');
          if (name === '?') name = '';
        }
      } else {
        name = data === '?' ? '' : data;
      }

      // If name is missing but playerId exists, look up in dictionary or store
      if (!name && playerId) {
        if (this.dictionary.names_by_id && this.dictionary.names_by_id[playerId]) {
          name = this.dictionary.names_by_id[playerId];
        } else {
          const pById = app.store.getById('nagusi_players', String(playerId));
          if (pById) {
            name = pById.attribute('name');
            if (!dorsal && pById.number()) {
              dorsal = String(pById.number());
            }
          }
        }
      }
      return {
        data,
        name,
        dorsal,
        playerId,
        index
      };
    }).filter(item => item.name).map(item => {
      const data = item.data,
        name = item.name,
        dorsal = item.dorsal,
        playerId = item.playerId,
        index = item.index;
      const searchNameNorm = normalize(name);
      let officialName = name;
      let aliasesStr = '';
      const lineupPlayer = app.store.all('nagusi_players').find(p => {
        const pNameNorm = normalize(p.attribute('name'));
        const pAliases = (p.attribute('aliases') || '').split(/[;,]/).map(s => normalize(s));
        return pNameNorm === searchNameNorm || pAliases.includes(searchNameNorm);
      });
      if (lineupPlayer) {
        officialName = lineupPlayer.attribute('name');
        aliasesStr = lineupPlayer.attribute('aliases') || '';
      } else {
        const localLineupPlayers = this.dictionary.aliases || {};
        const matchOfficial = Object.keys(localLineupPlayers).find(oname => {
          if (normalize(oname) === searchNameNorm) return true;
          const aliases = (localLineupPlayers[oname] || '').split(/[;,]/).map(s => normalize(s));
          return aliases.includes(searchNameNorm);
        });
        if (matchOfficial) {
          officialName = matchOfficial;
          aliasesStr = localLineupPlayers[matchOfficial] || '';
        }
      }
      const namesToTry = [name];
      if (officialName && !namesToTry.some(n => normalize(n) === normalize(officialName))) {
        namesToTry.push(officialName);
      }
      if (aliasesStr) {
        aliasesStr.split(/[;,]/).forEach(a => {
          const trimmedA = a.trim();
          if (trimmedA && !namesToTry.some(n => normalize(n) === normalize(trimmedA))) {
            namesToTry.push(trimmedA);
          }
        });
      }
      const localPhotos = this.dictionary.photos || {};
      let photoUrl = null;
      if (playerId) {
        let idMatches = false;
        if (this.dictionary.names_by_id && this.dictionary.names_by_id[playerId]) {
          const idOfficialName = this.dictionary.names_by_id[playerId];
          const idAliasesStr = this.dictionary.aliases ? this.dictionary.aliases[idOfficialName] || '' : '';
          const validNamesForId = [idOfficialName, ...idAliasesStr.split(/[;,]/).map(s => s.trim())].filter(Boolean);
          if (namesToTry.some(nt => validNamesForId.some(vn => normalize(vn) === normalize(nt)))) {
            idMatches = true;
          }
        } else {
          const pById = app.store.getById('nagusi_players', String(playerId));
          if (pById) {
            const idOfficialName = pById.attribute('name');
            const idAliasesStr = pById.attribute('aliases') || '';
            const validNamesForId = [idOfficialName, ...idAliasesStr.split(/[;,]/).map(s => s.trim())].filter(Boolean);
            if (namesToTry.some(nt => validNamesForId.some(vn => normalize(vn) === normalize(nt)))) {
              idMatches = true;
            }
          }
        }
        if (idMatches) {
          if (this.dictionary.photos_by_id && this.dictionary.photos_by_id[playerId]) {
            photoUrl = this.dictionary.photos_by_id[playerId];
          }
          if (!photoUrl) {
            const pById = app.store.getById('nagusi_players', String(playerId));
            if (pById && pById.attribute('photoUrl')) {
              photoUrl = pById.attribute('photoUrl');
            }
          }
        }
      }
      if (!photoUrl) {
        for (const n of namesToTry) {
          const nNorm = normalize(n);
          const matchKey = Object.keys(localPhotos).find(kn => normalize(kn) === nNorm);
          if (matchKey) {
            photoUrl = localPhotos[matchKey];
            break;
          }
        }
      }
      if (!photoUrl) {
        const playerFromRatings = app.store.all('nagusi_players').find(p => {
          const pNameNorm = normalize(p.attribute('name'));
          return namesToTry.some(n => normalize(n) === pNameNorm);
        });
        photoUrl = playerFromRatings ? playerFromRatings.attribute('photoUrl') : null;
      }
      return m("div", {
        className: "Lineup-bench-player",
        key: index
      }, m("div", {
        className: "Lineup-bench-player-photo-wrapper"
      }, photoUrl ? m("img", {
        src: photoUrl,
        alt: name,
        className: "Lineup-bench-player-img"
      }) : m("div", {
        className: "Lineup-bench-player-no-photo Lineup-kit-".concat(kit)
      }, dorsal || '?')), m("div", {
        className: "Lineup-bench-player-info"
      }, dorsal && photoUrl && m("span", {
        className: "Lineup-bench-player-dorsal-tag"
      }, dorsal), m("span", {
        className: "Lineup-bench-player-name"
      }, name)));
    }))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/lineup/Lineup', Lineup);